module.exports = __webpack_public_path__ + "img/nav-design-ringsets.af550ee.webp";